import React, { useContext } from 'react'
import '../App.css'
import { Link } from 'react-router-dom'
import { auth } from '../config/firebase'
import { signOut} from 'firebase/auth'
import { toast } from 'react-toastify'
import { AuthContext } from '../context/AuthContext'
const Navbar = () => {
     const {currentuser, isactive} = useContext(AuthContext)
    const logout=() => {
      signOut(auth);
      toast.success("You have Logged Out Successfully");

    
    }
     
  return (
    <div>
      
        <nav className="navbar main-nav">
    <div className="container-fluid" style={{alignContent:"center"}}>
    <Link to='/signup' className="navbar-brand">
      <h1 style={{color:"white"}}>vTalk</h1>
    </Link>
    <div className="d-flex " style={{gap:"20px", marginRight:"10px"}} >
        {!isactive?
        <div className='d-flex' style={{gap:"20px"}}>
      <Link to='/login' className="btn btn-outline-light login-btn" type="submit" style={{fontSize:"1.3rem"}}>Login</Link>
      <Link to='/signup' className="btn btn-outline-light login-btn" type="submit" style={{fontSize:"1.3rem"}}>Sign In</Link>
      </div>
      :
      <div className='d-flex mob-main-nav' style={{gap:"10px", marginRight:"10px"}}>
      <p style={{margin:"auto", fontSize:"1.3rem", color:"white"}}>
        Hello {currentuser.displayName}
        </p>
        <Link to='/signup' className="btn btn-outline-dark" type="submit" style={{margin:"auto 20px", fontSize:"1.3rem" }} onClick={logout} >Logout</Link>
       
      </div>}
    </div>
    
  </div>
</nav>
    </div>
  )
}

export default Navbar